import { Dialog } from "@/Dialog";

export interface ReserveConfirmItem {
  label: string;
  value?: string | null;
}

interface ReserveConfirmDialogProps {
  visible: boolean;
  title?: string;
  description?: string;
  items?: ReserveConfirmItem[];
  confirmLabel?: string;
  isPending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * 예약 신청 직전 최종 확인 다이얼로그.
 * "예약 하기" 버튼을 누르면 바로 예약 API가 호출되던 것을 한 번 막아준다.
 */
const ReserveConfirmDialog = ({
  visible,
  title = "예약하시겠습니까?",
  description = "아래 내용으로 예약을 신청합니다.",
  items = [],
  confirmLabel = "예약하기",
  isPending = false,
  onCancel,
  onConfirm,
}: ReserveConfirmDialogProps) => {
  const filledItems = items.filter((item) => !!item.value);

  return (
    <Dialog visible={visible} persist={false} onClose={onCancel}>
      <div className="p-6 text-center">
        <h3 className="mb-4 text-lg font-bold text-gray-800">{title}</h3>
        {filledItems.length > 0 && (
          <dl className="p-3 mb-4 text-sm text-left bg-gray-100 rounded-lg">
            {filledItems.map((item) => (
              <div
                key={item.label}
                className="flex gap-3 justify-between py-0.5"
              >
                <dt className="shrink-0 text-gray-500">{item.label}</dt>
                <dd className="font-semibold text-right text-black break-keep">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        )}
        <p className="mb-6 text-sm text-gray-600 whitespace-pre-line">
          {description}
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            className="flex-1 py-2 font-semibold text-gray-700 bg-white rounded-full border border-gray-300"
            onClick={onCancel}
            disabled={isPending}
          >
            취소
          </button>
          <button
            type="button"
            className="flex-1 py-2 font-semibold text-white bg-orange-400 rounded-full disabled:opacity-60"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? "예약 중..." : confirmLabel}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ReserveConfirmDialog;
